import { cn } from "@/lib/utils";

type LivePulseProps = {
  tone?: "success" | "warning" | "accent" | "danger";
  className?: string;
  label?: string;
};

const toneRing: Record<NonNullable<LivePulseProps["tone"]>, string> = {
  success: "bg-success",
  warning: "bg-warning",
  accent: "bg-primary",
  danger: "bg-destructive",
};

export function LivePulse({ tone = "success", className, label }: LivePulseProps) {
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span className="relative inline-flex size-2 items-center justify-center">
        <span
          className={cn(
            "absolute inline-flex size-full animate-ping rounded-full opacity-60",
            toneRing[tone],
          )}
        />
        <span className={cn("relative inline-flex size-2 rounded-full", toneRing[tone])} />
      </span>
      {label ? <span className="text-xs text-ink-soft">{label}</span> : null}
    </span>
  );
}
